import { CharacterType } from 'types/enums';

const _getSvgAsset = (path) => {
  try {
    return require(`assets/svg${path}`);
  } catch (err) {
    return null;
  }
};

const _getCharacterName = (character) => {
  if (character === 'Ñ') return 'N-spanish';
  if (character === 'ñ') return 'n-spanish';

  return character;
};

const GetSvgPath = (characterType, characterCase, character) => {
  const path =
    characterType === CharacterType.NUMBER
      ? `/${characterType}/${character}.svg`
      : `/${characterType}/${characterCase}/${_getCharacterName(
          character
        )}.svg`;

  return _getSvgAsset(path);
};

export default GetSvgPath;
